/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ComunicazioneEmailAvvioDTO { 
    /**
     * Id dell\'invio da consultare nello storico.
     */
    invio_id?: string;
    /**
     * Cittadini scelti (compresi quelli senza email).
     */
    destinatari_totali?: number;
    /**
     * Cittadini senza indirizzo email, ai quali non verra\' inviato nulla.
     */
    saltati_senza_email?: number;
}

